import {ArchivableItemGQL, ArchivableItemREST} from 'archive/ArchiveConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {RegistryFilterOption} from 'constants/RegistryConstants';
import {SchemaSelectorSchema} from 'samples/SchemaSelector';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

export interface AnonymousSchema {
  allFields: Array<SchemaField>;
  // Unarchived fields
  fields: Array<SchemaField>;
  id: string;
  // only used for versioned schemas
  parentSchemaId?: string;
  hasValidationRules?: boolean;
}

export interface DisplayIdPrefix {
  prefix: string;
}

export type Schema = AnonymousSchema & ArchivableItemREST;

export type PrefixedSchema = Schema & DisplayIdPrefix;

export interface SchemaWithDescription extends Schema {
  schemaDescription: string;
}

export function isSchemaWithDescription(schema: Schema): schema is SchemaWithDescription {
  return schema.hasOwnProperty('schemaDescription');
}

export interface SchemaTypeFilterOption {
  id: string;
  name: string;
  schemaType: string;
  isSchemaTypeFilterOption: true;
}

export function isSchemaTypeFilterOption(
  data: SchemaSelectorSchema | SchemaTypeFilterOption | RegistryFilterOption
): data is SchemaTypeFilterOption {
  return data != null && (data as SchemaTypeFilterOption).isSchemaTypeFilterOption;
}

export const SchemaPreferences = {
  SET_TAG_SCHEMA_MODAL_OPTION: 'setTagSchemaModal.option',
};

export type SchemaInterface = ArchivableItemGQL;

export const SCHEMA_INTERFACE_SUPPORTED_TYPES = [
  ModelTypeConstants.BASIC_FOLDER_ITEM,
  ModelTypeConstants.ENTRY,
  ModelTypeConstants.MIXTURE,
  ModelTypeConstants.MOLECULE,
  ModelTypeConstants.DNA_OLIGO,
  ModelTypeConstants.RNA_OLIGO,
  ModelTypeConstants.RNA_SEQUENCE,
  ModelTypeConstants.PROTEIN,
  ModelTypeConstants.SEQUENCE,
];

export interface ImplementedStaticSchemaInterface {
  interfaceId: string;
}

export interface BenchlingAppSummary {
  name: string;
  url: string;
}

export interface SchemaWithInterfaces extends Schema {
  interfaces: Array<{id: string}>;
}
